import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "error__text" }, " We couldn't find the page you're looking for. ", -1)
const _hoisted_2 = { class: "error__text" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" If you believe this is an error, please ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" contact us")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(". ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_error = _resolveComponent("error")!

  return (_openBlock(), _createBlock(_component_error, {
    status: "404",
    title: "Not Found"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("p", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_router_link, {
          class: "anchor--primary",
          to: "/#contact"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _hoisted_5
      ])
    ]),
    _: 1
  }))
}